import api from '.'

export const insights = {
  getForParticipant (trialId, participantId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/participants/${participantId}/insights`, null, success, fail)
  },
  refreshForParticipant (trialId, participantId, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/participants/${participantId}/insights/refresh`, null, success, fail)
  },
  getForTrial (trialId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/insights`, null, success, fail)
  },
  refreshForTrial (trialId, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/insights/refresh`, null, success, fail)
  }
}
